import { isSubmissionDetailPath } from "@/lib/record-detail-chrome"

export const GRADING_SUBMISSIONS_SECONDARY_PANEL_ID = "grading-submissions"

export function isSubmissionDetailSecondaryPanelRoute(pathname: string): boolean {
  return isSubmissionDetailPath(pathname)
}

export function isSubmissionDetailSecondaryPanelVisible(
  pathname: string,
  _activePanel: string | null,
): boolean {
  return shouldSubmissionDetailSecondaryPanelBeOpen(pathname)
}

export function shouldSubmissionDetailSecondaryPanelBeOpen(
  pathname: string,
): boolean {
  return isSubmissionDetailSecondaryPanelRoute(pathname)
}
